module.exports = __webpack_public_path__ + "img/s00136.38ce9bd1.png";